import http from '@/plugins/axios';

export async function get_hotels(payload) { 
    let { search, limit, next_page, province_slug, meal_types, cuisines } = payload; 
    let _response = {};
    if (payload.type === 'hotel') {
        const response = await http.get(`hotels?search=${search}&page=${next_page}&limit=${limit}&province_slug=${province_slug}&meal_types=${meal_types}&cuisines=${cuisines}`);
        _response.main_location = response.data.hotels; 
        _response.meta = response.data.meta;
        return _response;
    } else {
        const response = await http.get(`restaurants?search=${search}&page=${next_page}&limit=${limit}&province_slug=${province_slug}&meal_types=${meal_types}&cuisines=${cuisines}`);
        _response.main_location = response.data.restaurants;
        _response.cuisines = response.data.cuisines;
        _response.meals = response.data.meals;
        _response.meta = response.data.meta;
        return _response;
    }
}

export async function get_locations(payload) {

    let data = {
        type_id: payload.type_id,
        type: payload.type,
    }
    // const response = await http.get(`locations?type_id=${data.type_id}&type=${data.type}`);
    const response = await http.get(`g/TABLE?restaurant_id=${data.type_id}&type=${data.type}`);
    // maps array to nest
    // const nest = (items, id = 0, link = 'parent_id') =>
    //     items
    //         .filter(item => item[link] === id)
    //         .map(item => ({
    //             ...item,
    //             children: nest(items, item.id)
    //         }));

    return response.data;

}

export async function search_place(payload) {
    const response = await http.get(`customer/search`, {params: payload});
    return response.data;

}

export async function get_restaurant(payload) {
    const response = await http.get(`restaurants/${payload}`);
    return response;

}

export async function get_hotel(payload) {
    const response = await http.get(`hotels/${payload}`);
    return response;

}